import React from "react";
import { ArrowLeft, Save, Loader2, FileText, Plus, Library, Brain } from "lucide-react";
import { Button } from "../ui/button";

export function EditorToolbar({ editor }) {
  const {
    id, isEditing, navigate, selectedTemplate, saving,
    contextualReviewOpen, setContextualReviewOpen,
    setDraftPreviewOpen, setTemplateSheetOpen, setClauseSheetOpen,
    handleSave,
  } = editor;

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-4">
        <Button
          variant="ghost" size="icon"
          onClick={() => navigate(isEditing ? `/contracts/${id}` : "/contracts")}
          className="rounded-sm"
          data-testid="back-btn"
        >
          <ArrowLeft size={20} />
        </Button>
        <div>
          <h1 className="text-2xl font-semibold text-slate-900 dark:text-white" style={{ fontFamily: "'Outfit', sans-serif" }}>
            {isEditing ? "Edit Contract" : "New Contract"}
          </h1>
          <p className="text-slate-500">
            {selectedTemplate ? `Using template: ${selectedTemplate.name}` : ""}
          </p>
        </div>
      </div>

      <div className="flex items-center gap-2">
        <Button
          onClick={() => setContextualReviewOpen(!contextualReviewOpen)}
          variant={contextualReviewOpen ? "default" : "outline"}
          className={`gap-2 rounded-sm ${contextualReviewOpen ? "bg-violet-600 hover:bg-violet-700 text-white" : "border-violet-300 text-violet-700 hover:bg-violet-50"}`}
          data-testid="ai-review-btn"
        >
          <Brain size={16} />
          {contextualReviewOpen ? "Close AI Review" : "AI Review"}
        </Button>

        <Button onClick={() => setDraftPreviewOpen(true)} variant="outline" className="gap-2 rounded-sm" data-testid="view-draft-btn">
          <FileText size={16} /> View Draft
        </Button>

        <Button variant="outline" className="gap-2 rounded-sm" onClick={() => setTemplateSheetOpen(true)} data-testid="templates-btn">
          <Library size={16} /> Templates
        </Button>

        <Button variant="outline" className="gap-2 rounded-sm" onClick={() => setClauseSheetOpen(true)} data-testid="clauses-btn">
          <Plus size={16} /> Clauses
        </Button>

        <Button
          onClick={handleSave} disabled={saving}
          className="gap-2 rounded-sm bg-slate-900 hover:bg-slate-800 dark:bg-cyan-500 dark:text-slate-900"
          data-testid="save-btn"
        >
          {saving ? <Loader2 size={16} className="animate-spin" /> : <Save size={16} />}
          {saving ? "Saving..." : "Save Contract"}
        </Button>
      </div>
    </div>
  );
}
